import produce from 'immer';
import {
  GET_STORE_EMAILS_START,
  GET_STORE_EMAILS_SUCCESS,
  GET_STORE_EMAILS_FAILED,
  UPDATE_STORE_EMAILS_DATA_START,
  UPDATE_STORE_EMAILS_DATA_SUCCESS,
  UPDATE_STORE_EMAILS_DATA_FAILED
} from '../actions/store_emails';


const initialState = {
  storeEmails: {
    primaryEmail: '',
    receivingEmail: '',
    appointmentEmail: '',
    _id: '',
    storeId: '',
    createdAt: '',
    updatedAt: ''
  },
  loadingStoreEmails: false
};

const formReducer = produce((state: IStoreEmailsState = initialState, action) => {
  switch (action.type) {
    case GET_STORE_EMAILS_START: {
      state.loadingStoreEmails = true;
      break;
    }
    case GET_STORE_EMAILS_SUCCESS: {
      const { data } = action;

      state.storeEmails = data;
      state.loadingStoreEmails = false;

      break;
    }
    case GET_STORE_EMAILS_FAILED: {
      state.loadingStoreEmails = false;
      break;
    }

    case UPDATE_STORE_EMAILS_DATA_START: {
      state.loadingStoreEmails = true;
      break;
    }
    case UPDATE_STORE_EMAILS_DATA_SUCCESS: {
      const { emails } = action.data;

      state.storeEmails = emails;
      state.loadingStoreEmails = false;

      break;
    }
    case UPDATE_STORE_EMAILS_DATA_FAILED: {
      state.loadingStoreEmails = false;
      break;
    }

    default:
      break;
  }
}, initialState);

export default formReducer;
